/**
 * Ablage der Tokens im Browser -- nur im Speicher dieses Moduls
 * (docs/app-integration-oidc.md, "Tokens im Browser: Regeln").
 *
 * Bis Oktober 2026 lagen Access- und Refresh-Token im localStorage. Dort
 * liest sie jedes eingeschleuste Skript und jeder Infostealer (die Datei
 * liegt im Browserprofil auf der Platte) und kann die Sitzung tagelang
 * weiterverwenden. Jetzt:
 *
 *  - Access-Token: nur hier im Speicher; weg beim Neuladen.
 *  - Lokaler Passwortfluss: das Refresh-Token sieht der Browser-Code nie,
 *    der Server setzt es als HttpOnly-Cookie (Path=/api/auth). Nach dem
 *    Neuladen holt POST /api/auth/refresh ein neues Access-Token.
 *  - SSO (Keycloak, public client): das Keycloak-Refresh-Token bleibt nur
 *    fuer die Lebensdauer der Seite im Speicher. Nach dem Neuladen holt
 *    trySilentLogin() (prompt=none) neue Tokens aus der Keycloak-Sitzung.
 */

let accessToken: string | null = null;
let oidcRefreshToken: string | null = null;

/** Alte Schluessel aus der localStorage-Zeit, beim Laden einmal geloescht. */
const LEGACY_KEYS = ['accessToken', 'refreshToken'];

export function getAccessToken(): string | null {
  return accessToken;
}

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getOidcRefreshToken(): string | null {
  return oidcRefreshToken;
}

export function setOidcRefreshToken(token: string | null): void {
  oidcRefreshToken = token;
}

export function clearSession(): void {
  accessToken = null;
  oidcRefreshToken = null;
}

/**
 * Tokens aus der localStorage-Zeit entfernen: sonst laege ein 7-Tage-
 * Refresh-Token nach dem Update weiter im Profil, obwohl es niemand mehr
 * liest.
 */
export function purgeLegacyTokenStorage(): void {
  try {
    for (const key of LEGACY_KEYS) window.localStorage.removeItem(key);
  } catch {
    // localStorage gesperrt (Privatmodus, iframe): dann liegt dort auch nichts.
  }
}

purgeLegacyTokenStorage();
